
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import ReservationPayload from "@/store/modules/reservation/models";
    import PaxValidationError, { PaxValidationErrorValue } from "@/models/reservation/paxValidationError";
    import DatePicker from "@/app/common/components/DatePicker.vue";
    import { ReservationRoomPaxModel } from "@/apiManager/reservation/reservationData";
    import { LoginTypeEnum } from "@/apiManager/login/loginData";
    import { PaxFormEnum } from "@/apiManager/_common/enums";
    import { PaxCAAModel, PaxFindByCAAMemberQuery } from "@/apiManager/pax/paxData";

    @Component
    export default class PaxFormCAAAgent extends Vue
    {
        @Prop({ type: Number, required: true }) private readonly indexRoom!: number;
        @Prop({ type: Number, required: true }) private readonly indexPax!: number;
        @Prop({ type: Object, required: true }) private readonly paxValidationError!: PaxValidationErrorValue;

        m_CAAMemberError: string = "";
        m_CAAProspectError: string = "";
        m_IsMemberValid: boolean = false;

        get components()
        {
            let components = {
                "date-picker": DatePicker
            };

            return components;
        }

        get getPaxSalutationList() : {value: string, label: string}[]
        {
            return [
                {value: "", label: ""},
                {value: "M.", label: "M."},
                {value: "Mlle", label: "Mlle"},
                {value: "Mme", label: "Mme"},
                {value: "Mr", label: "Mr"},
                {value: "Mrs", label: "Mrs"},
                {value: "Ms", label: "Ms"}
            ];
        }

        get getPaxGenderList() : {value: string, label: string}[]
        {
            return [
                {value: "", label: ""},
                {value: "F", label: this.i18n(this.getRezToursLanguageEnum.female)},
                {value: "M", label: this.i18n(this.getRezToursLanguageEnum.male)}
            ];
        }

        get getPaxDisabled(): boolean
        {
            return (this.indexRoom === 0) && (this.indexPax === 0) && (this.$tStore.state.authenticationModal.isAuth) && (this.$tStore.state.authenticationModal.authType === LoginTypeEnum.Pax);
        }

        get getPaxFormEnum(): typeof PaxFormEnum
        {
            return PaxFormEnum;
        }

        get getPax(): ReservationRoomPaxModel
        {
            return this.$tStore.state.reservationState.detail.listRoom[this.indexRoom].listPax[this.indexPax];
        }

        get getFirstPax(): ReservationRoomPaxModel
        {
            return this.$tStore.state.reservationState.detail.listRoom[0].listPax[0];
        }

        get getOptionalAsterisk(): string
        {
            if (this.$tStore.state.authenticationModal.authType === LoginTypeEnum.Agent)
            {
                return "";
            }
            else
            {
                return " *";
            }
        }

        get getSpecialRequestIsVisible(): boolean
        {
            return (this.$tStore.state.authenticationModal.authType === LoginTypeEnum.Agent);
        }

        getFormatPhoneNumber(phoneNumber: string): string
        {
            //Filter only numbers from the input
            let cleaned = (phoneNumber).replace(/\D/g, "");

            //Check if the input is of correct length
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

            if (match)
            {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }

            return phoneNumber;
        }

        getFormatPostalCode(postalCode: string): string
        {
            let cleaned = (postalCode).replace(/(-)|( )/g, "");

            if(cleaned.length===6)
            {
                return cleaned.substr(0, 3).toUpperCase()+" "+cleaned.substr(3).toUpperCase();
            }

            return postalCode;
        }

        get salutation(): string
        {
            return this.getPax.salutation;
        }
        set salutation(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxSalutation(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get lastName(): string
        {
            return this.getPax.lastName;
        }
        set lastName(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxLastName(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get firstName(): string
        {
            return this.getPax.firstName;
        }
        set firstName(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxFirstName(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get telephone(): string
        {
            return this.getPax.tel1;
        }
        set telephone(value: string)
        {
            let formatPhoneNumber = this.getFormatPhoneNumber(value);

            let payload = new ReservationPayload.Mutations.SetReservationPaxTelephone(
                formatPhoneNumber,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get tel3(): string
        {
            return this.getPax.tel3;
        }
        set tel3(value: string)
        {
            let formatPhoneNumber = this.getFormatPhoneNumber(value);

            let payload = new ReservationPayload.Mutations.SetReservationPaxTel3(
                formatPhoneNumber,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get email(): string
        {
            return this.getPax.email;
        }
        set email(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxEmail(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get address(): string
        {
            return this.getPax.address;
        }
        set address(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxAddress(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get city(): string
        {
            return this.getPax.city;
        }
        set city(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxCity(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get province(): string
        {
            return this.getPax.province;
        }
        set province(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxProvince(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get postal(): string
        {
            return this.getPax.postal;
        }
        set postal(value: string)
        {
            //let formatPostalCode = this.getFormatPostalCode(value);

            let payload = new ReservationPayload.Mutations.SetReservationPaxPostal(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get gender(): string
        {
            return this.getPax.gender;
        }
        set gender(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxGender(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get birthDate(): string
        {
            return this.getPax.birthDate;
        }
        set birthDate(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxBirthdate(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get isCAAMember(): boolean
        {
            return this.getPax.isCAAMember;
        }
        set isCAAMember(value: boolean)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxIsCAAMember(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get caaMember(): string
        {
            return this.getPax.caaMember;
        }
        set caaMember(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxCAAMember(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get allergies(): string
        {
            return this.getPax.allergies;
        }
        set allergies(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxAllergies(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get hasNoAllergies(): boolean
        {
            return this.getPax.hasNoAllergies;
        }
        set hasNoAllergies(value: boolean)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxHasNoAllergies(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get medicalCondition(): string
        {
            return this.getPax.medicalCondition;
        }
        set medicalCondition(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxMedicalCondition(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get hasNoMedicalCondition(): boolean
        {
            return this.getPax.hasNoMedicalCondition;
        }
        set hasNoMedicalCondition(value: boolean)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxHasNoMedicalCondition(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get specialRequest(): string
        {
            return this.getPax.specialRequest;
        }
        set specialRequest(value: string)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxSpecialRequest(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        get useSameAddress(): boolean
        {
            return this.getPax.useSameAddress;
        }
        set useSameAddress(value: boolean)
        {
            let payload = new ReservationPayload.Mutations.SetReservationPaxSameAddress(
                value,
                this.indexRoom,
                this.indexPax
            );
            this.$tStore.commit(payload);
        }

        async loadCAAMember()
        {
            try
            {
                this.m_CAAMemberError = "";
                this.m_CAAProspectError = "";

                let isValid: boolean = false;

                let callAPI: boolean = false;
                if (this.caaMember.length === 0)
                {
                    callAPI = false;
                }
                else
                {
                    if (this.isCAAMember)
                    {
                        if ((/^\d{10}$/.test(this.caaMember)))
                        {
                            callAPI = true;
                        }
                        else
                        {
                            callAPI = false;
                            this.m_CAAMemberError = this.i18n(this.getRezToursLanguageEnum.caaMember) + " " + this.i18n(this.getRezToursLanguageEnum.isInvalid);
                        }
                    }
                    else
                    {
                        if (this.caaMember.length === 7)
                        {
                            callAPI = true;
                        }
                        else
                        {
                            try
                            {
                                let value: number = Number.parseInt(this.caaMember);
                                let s : string = "0000000" + value;
                                this.caaMember = s.substring(s.length - 7);

                                return;
                            }
                            catch
                            {
                                callAPI = false;
                                this.m_CAAProspectError = this.i18n(this.getRezToursLanguageEnum.caaProspect) + " " + this.i18n(this.getRezToursLanguageEnum.isInvalid);
                            }
                        }
                    }
                }

                let paxModel: PaxCAAModel = new PaxCAAModel();
                if (callAPI)
                {
                    let query: PaxFindByCAAMemberQuery = new PaxFindByCAAMemberQuery();
                    query.isMember = this.isCAAMember;
                    query.caaMember = this.caaMember;

                    try
                    {
                        paxModel = await this.$apiManager.pax.findByCAAMemberAsync(query);
                    }
                    catch
                    {
                    }

                    let paxCode = paxModel?.code ?? "";
                    if (paxCode.length === 0)
                    {
                        paxModel = new PaxCAAModel();

                        if (this.isCAAMember)
                        {
                            this.m_CAAMemberError = this.i18n(this.getRezToursLanguageEnum.caaMember) + " " + this.i18n(this.getRezToursLanguageEnum.isNotFound);
                        }
                        else
                        {
                            this.m_CAAProspectError = this.i18n(this.getRezToursLanguageEnum.caaProspect) + " " + this.i18n(this.getRezToursLanguageEnum.isNotFound);
                        }
                    }
                    else
                    {
                        isValid = true;
                    }
                }

                let payload = new ReservationPayload.Mutations.SetReservationPaxCAA(
                    paxModel,
                    this.indexRoom,
                    this.indexPax
                );
                this.$tStore.commit(payload);

                this.m_IsMemberValid = isValid;
            }
            catch
            {

            }
        }

        caaMember_Input(): void
        {
            this.caaMember = this.caaMember.replace(/\D/g, "");
        }

        @Watch("caaMember")
        onWatchDisplay()
        {
            this.loadCAAMember();
        }
    }
